import { Breadcrumbs } from '../components/Breadcrumbs'
import { LINKS } from '../config/links'
import { Seo } from '../seo/Seo'
import { breadcrumbSchema } from '../seo/schema'
import './Legal.css'

export function Privacy() {
  return (
    <main className="legal">
      <Seo
        title="Privacy Policy"
        description="Privacy policy for Music24 Jewish music radio — how we handle data in our apps and website."
        path="/privacy"
        jsonLd={breadcrumbSchema([
          { name: 'Home', path: '/' },
          { name: 'Privacy', path: '/privacy' },
        ])}
      />
      <Breadcrumbs
        items={[
          { name: 'Home', path: '/' },
          { name: 'Privacy' },
        ]}
      />
      <h1>Privacy Policy</h1>
      <p className="legal__updated">Last updated: August 3, 2026</p>

      <section>
        <h2>Overview</h2>
        <p>
          Music24 (“we”, “us”) provides a Jewish music radio experience through
          our mobile apps and website. This policy explains what information we
          collect and how we use it.
        </p>
      </section>

      <section>
        <h2>Information we collect</h2>
        <p>
          We may collect limited technical information needed to operate the
          service, such as device type, app version, crash reports, and general
          usage analytics. We do not require an account to listen.
        </p>
      </section>

      <section>
        <h2>How we use information</h2>
        <p>
          We use this information to stream audio, improve reliability, fix
          bugs, and understand aggregate listening patterns. We do not sell your
          personal information.
        </p>
      </section>

      <section>
        <h2>Third-party services</h2>
        <p>
          Audio streams are provided by our streaming partners. The apps may use
          standard platform services (such as crash reporting or store
          analytics). Those providers process data under their own policies.
        </p>
      </section>

      <section>
        <h2>Children</h2>
        <p>
          Music24 is a general-audience music service. We do not knowingly
          collect personal information from children.
        </p>
      </section>

      <section>
        <h2>Contact</h2>
        <p>
          Questions about privacy? Email{' '}
          <a href={`mailto:${LINKS.supportEmail}`}>{LINKS.supportEmail}</a>.
        </p>
      </section>
    </main>
  )
}
